// extracted by mini-css-extract-plugin
module.exports = {"textOverflow":"name_textOverflow_1oQet"};